export default __webpack_public_path__ + "static/media/benne-regular-webfont.c84b2416.ttf";